import image1 from '../../../../assets/images/work/norcat-lock-tag/LOTO_detailed_img_1.webp';
import image2 from '../../../../assets/images/work/norcat-lock-tag/LOTO_detailed_img_2.webp';
import image4 from '../../../../assets/images/work/norcat-lock-tag/LOTO_detailed_abovefooter.webp';

import artwork from '../../../../assets/images/art_2.png';
import eoLogoLowJpg from '../../../../assets/images/eologo-low.webp';
import eoLogoJpg from '../../../../assets/images/eologo.webp';

const Data_norcatLockTag = {
  content: (
    <>
      {/* PROBLEM + CHALLENGES */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                {/* PROBLEM */}
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">PROBLEM</h4>

                  <div className="paragraph light-1">
                    <p>
                      Lockout and tagout procedures are critical for preventing serious incidents, but classroom training can
                      only go so far. Learners may understand the theory, yet still struggle to apply procedures confidently
                      in the moment, especially when faced with unfamiliar equipment, real-time decision-making, and complex
                      workplace coordination.
                      <br />
                      <br />
                      NORCAT needed a way to bridge the gap between theory and practice by placing learners in realistic,
                      scenario-based experiences where they could build muscle memory and reinforce correct habits before
                      performing lockouts on the job.
                    </p>
                  </div>
                </div>

                {/* CHALLENGES */}
                <div className="col-lg-6 second-column">
                  <h4 className="heading heading-small light-2">CHALLENGES</h4>

                  <div className="paragraph light-1">
                    <p>
                      The challenge was creating an experience that feels authentic and teaches correct decision-making
                      step-by-step. The program needed to capture the realities of a workplace lockout, including how
                      different systems behave, where mistakes are commonly made, and what it looks like to follow the
                      right process every time.
                      <br />
                      <br />
                      It also needed to be engaging, easy to deliver, and measurable, supporting trainers with clear outcomes
                      and allowing learners to repeat scenarios until procedures become instinctive.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PROJECT CONTENT */}
      <div className="project-content">
        <div className="project-content-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-large dark-1">
                    A story-driven VR experience that turns lockout steps into safe, repeatable muscle memory.
                  </h2>

                  <div className="paragraph dark-1">
                    <p>
                      The NORCAT Lock and Tagout Program is an immersive, first-person virtual reality experience that places
                      learners in the role of a new employee being guided through real workplace lockout and tagout tasks.
                      Within 30 to 40 minutes, learners complete a sequence of realistic scenarios designed to reinforce safe
                      habits, correct order of operations, and the importance of communication.
                      <br />
                      <br />
                      Built as a PC VR experience for internal use, the program generates a user report that supports trainer
                      review and helps identify where learners need more practice.
                    </p>
                  </div>

                  <div className="heading heading-medium dark-1">
                    <p>Scenario-Based Learning</p>
                  </div>

                  <div className="paragraph dark-1">
                    <p>
                      Learners progress through multiple lockout situations, each focused on specific equipment types and
                      energy sources. The experience includes hydraulic lockout, conveyor lockout, and pneumatic lockout,
                      helping users understand how procedures change based on the system they're working with.
                      <br />
                      <br />
                      The program also teaches electrical lockout practices, including safe positioning and technique such as
                      the left-hand rule, and reinforces what to do when equipment cannot be restored immediately, using
                      status tags and following proper escalation steps.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image-wrapper">
            <div className="single-image">
              <img src={image1} alt="NORCAT Lock and Tag project screenshot 7" loading="lazy" decoding="async" />
            </div>
            <div className="single-image">
              <img src={image2} alt="NORCAT Lock and Tag project screenshot 8" loading="lazy" decoding="async" />
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-medium dark-1">Safety, Communication, and Accountability</h2>

                  <div className="paragraph dark-1">
                    <p>
                      Beyond the physical steps of lockout, the program reinforces real-world safety culture. Learners must
                      coordinate with supervisors and control groups, apply the right tags at the right times, and follow
                      procedures that prevent unsafe restart conditions. Built with input from trainers and industry
                      stakeholders, the experience reflects the expectations learners will encounter on the job.
                    </p>
                  </div>

                  <div className="text-list medium dark-1">
                    <ul>
                      <li>First-person, story-driven experience that builds engagement and retention</li>
                      <li>Hydraulic, conveyor, and pneumatic lockout scenarios</li>
                      <li>Electrical lockout instruction including the left-hand rule</li>
                      <li>Status tags and what to do when equipment cannot be restored</li>
                      <li>Supervisor and control group coordination embedded in the workflow</li>
                      <li>30 to 40 minute runtime with user reporting for trainers</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image">
            <img src={image4} alt="NORCAT Lock and Tag project screenshot 9" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>

      {/* RESULTS */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">RESULTS</h4>

                  <div className="paragraph light-1">
                    <p>
                      The NORCAT Lock and Tagout Program has strengthened hands-on readiness by giving learners a practical,
                      repeatable way to apply procedures in realistic situations. The experience helps move training beyond
                      theory, supporting safer decision-making, stronger muscle memory, and improved confidence before workers
                      perform lockouts in the field.
                      <br />
                      <br />
                      The program is now being rolled out across Ontario and expanding throughout Canada and into the United
                      States, supporting consistent lockout and tagout education for a broader workforce.
                    </p>
                  </div>
                </div>

                <div className="col-lg-5 offset-lg-1 second-column">
                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">PLATFORM</h4>
                    <div className="paragraph light-1">
                      <p>PC VR</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">CLIENT</h4>
                    <div className="paragraph light-1">
                      <p>NORCAT (Internal)</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">ONLINE</h4>
                    <div className="paragraph light-1">
                      <p>
                        <a href="https://www.norcat.org" target="_blank" rel="noreferrer">
                          www.norcat.org
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className="content-wrapper eo-acknowledgement">
                    <picture>
                      <source media="(max-width: 1024px)" srcSet={eoLogoLowJpg} />
                      <img className="eo-logo-primary" src={eoLogoJpg} alt="This Employment Ontario initiative is funded in part by the Government of Canada and the Government of Ontario." loading="lazy" decoding="async" />
                    </picture>
                    <p>
                      This{' '}
                      <a href="https://www.ontario.ca/page/employment-ontario" target="_blank" rel="noreferrer">
                        Employment Ontario
                      </a>{' '}
                      initiative is funded in part by the{' '}
                      <a href="https://www.canada.ca/en.html" target="_blank" rel="noreferrer">
                        Government of Canada
                      </a>{' '}
                      and the{' '}
                      <a href="https://www.ontario.ca/page/government-ontario" target="_blank" rel="noreferrer">
                        Government of Ontario
                      </a>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-content-footer">
            <div className="container">
              <div className="row align-items-lg-center">
                <div className="col-md-6">
                  <h3 className="heading heading-large light-1">
                    Have an idea?
                    <br />
                    Let's explore it together.
                  </h3>
                </div>
                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                  <div className="button-wrapper">
                    <a className="button button-1" href="/Contact">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="artwork artwork-2" aria-hidden="true">
            <img src={artwork} alt="" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </>
  ),
};

export default Data_norcatLockTag;
